
import { UserSliceType } from "../../slices/userSlice";

import { currentPremission2 } from "../../../../constants";

export const system_layout_actions = {
  selectClub: (state:UserSliceType, action: { payload: any }) => {
  state.selectedClub = action.payload;
},
setCurrentPermission: (state:UserSliceType['user'], action: { payload: any }) => {
  //pos_manual_price
  state.currentPremission = action.payload.permissions;
  state.has_manual_price_role = action.payload.has_manual_price_role || false
  state.pos_manual_price = action.payload.pos_manual_price || false
},
  setUser: (state: UserSliceType, action: { payload: any }) => {

    state.user ={ 
      ...state.user,
      ...action.payload};
      //@ts-ignore
      state.isEnableRole = true
      localStorage.setItem("isEnabledRules", "true");
  },
  ToggleRoleStatus: (state: UserSliceType, action: { payload: any }) =>{
    //@ts-ignore
    state.isEnableRole = action.payload
  } ,
  setPremission: (state: UserSliceType['user'], action: { payload: any }) => {
    
   state.currentPremission = currentPremission2;
  },
  changePremission: (state: UserSliceType['user'], action: { payload: any }) => {
    const clubId = action.payload.club_id;
    //@ts-ignore
    const clubName = state.user?.clubs?.find((item)=>item.club_id === clubId)?.club_name
    //@ts-ignore
    console.log(state.user?.clubs_roles_list?.find((item) => item.club_name === clubName)?.permissions);
    //@ts-ignore

      //@ts-ignore
      
      const rolesObject = state.user?.clubs_roles_list?.find((item) => item.club_name === clubName)
      const allowedSection = rolesObject?.club_allowed_sections
      
      //@ts-ignore
    const currentPremission = rolesObject?.permissions;
    const has_manual_price_role = rolesObject?.has_manual_price_role
    const pos_manual_price = rolesObject?.pos_manual_price
     console.log(currentPremission);
     
   
     if(currentPremission){
        currentPremission.forEach((role:any)=>{
      if(allowedSection.includes(role.section)){
       // role.read = true
      }else{
        role.read = false
        role.write = false
        role.create = false
        role.delete = false
      }
    })
     }
   
    console.log(currentPremission);
     state.has_manual_price_role = has_manual_price_role
     state.pos_manual_price = pos_manual_price
    //state.currentPremission = currentPremission || [];
    state.currentPremission = currentPremission2 || [];
    //@ts-ignore
    // const currentPremission = state.user?.clubs_roles_list?.find((item) => item.club_name === clubName)?.permissions;
    // state.currentPremission = currentPremission || [];
   
    //state.currentPremission = currentPremission2
  },
  setStage: (state: UserSliceType, action: { payload: any }) => {
    state.stage = action.payload;
  },
  setStatus: (state: UserSliceType, action: { payload: any }) => {
    state.status = action.payload;
  },
  setClubs: (state: UserSliceType, action: { payload: any }) => {
    state.clubs = action.payload;
  },
  addClub: (state: UserSliceType, action: { payload: any }) => {
    state.clubs.push(action.payload);
  },
  removeClub: (state: UserSliceType, action: { payload: any }) => {
    state.clubs = state.clubs.filter((club: any) => club.id !== action.payload);
  },
  setDictonary: (state: UserSliceType, action: { payload: any }) => {
    state.dictionary = action.payload;
  },
  setTimeFormat: (state: UserSliceType, action: { payload: any }) => {
    state.timeFormat = action.payload;
  },
  setLang: (state: UserSliceType['user'], action: { payload: any }) => {
    state.lang = action.payload;
  },
  resetUser: (state: any) => {
  state.user = {};
  state.status = "idle";
  state.clubs = [];
  state.selectedClub = 0;
  state.id = '';
  state.notification = true;
  state.timeFormat = 12;
  state.lang = 'en';
  state.darkMode = 'false';
  state.auth = false;
  state.loading = true;
  state.isEnableRole = false;
  state.error = null;
}

};
